













import { Component, Prop, Vue } from 'vue-property-decorator'
import PlayerCreateVue from '@/components/players/player.create.vue'
import { teamsClient } from '@/components/api/clients.context'

@Component({
    components: {
        PlayerCreateVue
    }
})
export default class teamAddNewPlayer extends Vue {
  teamId :string = ''
  async mounted () {
      console.log('mounted add newplayer')
      this.teamId = this.$route.params.id
      const team = await teamsClient.getTeamById(this.teamId)
      console.log(team)
  }

  saved () {
      this.$router.back()
  }
}

